// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/index.scss
// module id = 828
// module chunks = 0